class YamagaPageTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('a');
    if (!this.button) return;

    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);
  }

  onScroll() {
    this.classList.toggle('is-visible', window.scrollY > 400);
  }

  onClick(event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('yamaga-page-top')) {
  customElements.define('yamaga-page-top', YamagaPageTop);
}
